import { render } from "./ExamNotes.vue?vue&type=template&id=204ce62a"
import script from "./ExamNotes.vue?vue&type=script&lang=js"
export * from "./ExamNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__